import { MentoringReapplyForm } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Shared/MentoringReapplyForm';
import { useEditMentee } from 'hb-react/frontoffice/apps/Mentoring/hooks/useMutateMentee';
import {
  type CustomAttributeType,
  type MenteeProfile,
  type Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { LockScreen } from 'hb-react/shared/components/LockScreen';

interface ReapplyMenteeFormProps {
  applicationDescription: string;
  attributes: Array<CustomAttributeType>;
  menteeProfile: MenteeProfile & { status: 'rejected_can_reapply' };
  onSuccess: () => void;
  program: Program;
  title: string;
}

export const ReapplyMentee = ({
  program,
  menteeProfile,
  attributes,
  applicationDescription,
  title,
  onSuccess,
}: ReapplyMenteeFormProps) => {
  const { id: menteeId } = menteeProfile;
  const { mutateAsync: onReapply, isPending: isPendingReapply } = useEditMentee(
    {
      program,
      menteeId,
    },
  );

  return (
    <>
      {isPendingReapply && <LockScreen />}
      <MentoringReapplyForm
        attributes={attributes}
        applicationDescription={applicationDescription}
        mentoringProfile={menteeProfile}
        title={title}
        onSuccess={onSuccess}
        onReapply={onReapply}
      />
    </>
  );
};
